import React from 'react';
import _ from 'lodash';
import Moment from 'moment';
import ReactDropDownCalender from '../ReactDropDownCalender';

export class CopyWorks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copyTargetDate: Moment().format('YYYY/MM/DD'),
    };
  }

  handleSelectCalenderDate = date => {
    this.setState({ copyTargetDate: date });
  };

  render() {
    const styles = {
      content: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      label: {
        marginRight: 16,
      },
    };

    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>コピー先の日付を選択</span>
        </div>
        <div className='dialog-md__body text-center'>
          <div style={styles.content}>
            <div className='form-list__element'>
              <span className='label' style={styles.label}>
                日付
              </span>
              <ReactDropDownCalender
                value={this.state.copyTargetDate}
                onChange={date => this.handleSelectCalenderDate(date)}
              />
              {!_.isNull(this.props.copyErrorMessage) && (
                <div className='validate-message show'>
                  {this.props.copyErrorMessage}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            className='btn--sub'
            onClick={() => {
              this.props.onClose();
            }}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--effective'
            onClick={() => {
              this.props.onCopy(this.state.copyTargetDate);
            }}
          >
            コピーして追加
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CopyWorks.jsx